<template>
  <div class="m-0 p-0">
    <router-view />
  </div>
</template>

<script setup lang="ts">
</script>
